<template>
  <v-container class="pa-4" style="max-width: 300px;">
    <v-select
      v-model="currentLang"
      :items="languages"
      item-text="label"
      item-value="value"
      label="Tilni tanlang"
      outlined
      dense
      hide-details
      @change="changeLanguage"
    ></v-select>
<!-- 
    <div class="mt-4">
      <h3>{{ $t('greeting') }}</h3>
      <p>{{ $t('farewell') }}</p>
    </div> -->
  </v-container>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      currentLang: this.$i18n.locale,
      languages: [
        { label: "Lotin", value: "lotin" },
        { label: "Кирилл", value: "kirill" },
        { label: "Русский", value: "ru" }
      ]
    }
  },
  methods: {
    changeLanguage() {
      this.$i18n.locale = this.currentLang
      localStorage.setItem('lang', this.currentLang)
    }
  },
  mounted() {
    const savedLang = localStorage.getItem('lang')
    if (savedLang) {
      this.$i18n.locale = savedLang
      this.currentLang = savedLang
    }
  }
}
</script>

<style scoped>
h3 {
  font-weight: 600;
  margin-bottom: 4px;
}
</style>
